import {
  MUSIC_LESSON_FORMAT_VALUES,
  MUSIC_PHYSICAL_VENUE_VALUES,
  type MusicLessonFormat,
  type MusicPhysicalVenue,
} from '@tutor/types';

export const MUSIC_LESSON_SUBJECTS = [
  // Piano, keyboards and electronic keyboards
  'Piano', 'Digital Piano', 'Keyboard', 'Organ', 'Electone', 'Synthesizer',
  // Bowed strings and harp
  'Violin', 'Electric Violin', 'Viola', 'Cello', 'Electric Cello', 'Double Bass', 'Harp',
  // Guitar and plucked strings
  'Guitar', 'Classical Guitar', 'Acoustic Guitar', 'Electric Guitar', 'Bass Guitar',
  'Ukulele', 'Mandolin', 'Banjo',
  // Drums and percussion
  'Drums', 'Drum Kit', 'Electronic Drums', 'Snare Drum', 'Percussion',
  'Orchestral Percussion', 'Cajón', 'Conga', 'Bongo', 'Djembe', 'Handpan', 'Steelpan',
  'Steel Tongue Drum', 'Xylophone', 'Glockenspiel', 'Marimba', 'Vibraphone', 'Timpani',
  // Indian percussion
  'Tabla', 'Mridangam', 'Ghatam', 'Kanjira',
  // Malaysian traditional percussion
  'Kompang', 'Rebana',
  // Woodwinds
  'Piccolo', 'Flute', 'Recorder', 'Ocarina', 'Pan Flute', 'Clarinet', 'Bass Clarinet',
  'Oboe', 'English Horn', 'Bassoon',
  // Saxophones
  'Saxophone', 'Soprano Saxophone', 'Alto Saxophone', 'Tenor Saxophone', 'Baritone Saxophone',
  // Brass
  'Trumpet', 'Cornet', 'Flugelhorn', 'Trombone', 'Bass Trombone', 'French Horn',
  'Tenor Horn', 'Baritone Horn', 'Euphonium', 'Tuba',
  // Free-reed instruments
  'Accordion', 'Harmonica', 'Melodica', 'Harmonium',
  // Chinese bowed strings
  'Erhu', 'Gaohu', 'Banhu',
  // Chinese plucked and struck strings
  'Guzheng', 'Guqin', 'Pipa', 'Yangqin', 'Liuqin', 'Ruan', 'Zhongruan', 'Daruan',
  // Chinese wind instruments
  'Dizi', 'Xiao', 'Hulusi', 'Bawu', 'Suona', 'Sheng',
  // Chinese percussion
  'Chinese Percussion',
  // Indian instruments
  'Sitar', 'Veena', 'Bansuri', 'Sarod', 'Santoor', 'Tanpura', 'Carnatic Violin',
  // Malaysian and Southeast Asian instruments
  'Gamelan', 'Caklempong', 'Gambus', 'Sape', 'Angklung', 'Kulintang', 'Sompoton',
  'Seruling', 'Serunai',
  // Singing and vocal
  'Voice', 'Singing', 'Pop Vocal', 'Classical Vocal', 'Musical Theatre', 'Choir',
  // Music education and creative disciplines
  'Music Theory', 'Aural Training', 'Composition', 'Songwriting', 'Music Production',
  'Audio Engineering', 'DJ', 'Conducting', 'Band Coaching', 'Early Childhood Music',
] as const;

export const MUSIC_LEVELS = [
  'Beginner', 'Grade 1-2', 'Grade 3-5',
  'Grade 6-8', 'Diploma', 'Advanced',
];

export const MUSIC_AGE_GROUPS = [
  'Early childhood (3-5)', 'Children (6-12)', 'Teenagers (13-17)',
  'Adults (18-59)', 'Seniors (60+)',
];

export const MUSIC_EXAM_BOARDS = [
  'ABRSM', 'Trinity College London', 'Rockschool', 'LCM', 'AMEB', 'Yamaha',
];

export const MUSIC_LEARNING_GOALS = [
  'Learn for enjoyment', 'Build strong fundamentals', 'Prepare for graded exams',
  'Prepare for auditions or performances', 'Improve technique', 'Learn a specific song',
];

export const MUSIC_TEACHING_LANGUAGES = ['English', 'Malay', 'Mandarin', 'Cantonese', 'Tamil'];

export const MUSIC_LESSON_FORMATS = [
  { value: MUSIC_LESSON_FORMAT_VALUES[0], label: 'One-to-one' },
  { value: MUSIC_LESSON_FORMAT_VALUES[1], label: 'Group lesson' },
] as const satisfies ReadonlyArray<{ value: MusicLessonFormat; label: string }>;

export const MUSIC_PHYSICAL_VENUES = [
  { value: MUSIC_PHYSICAL_VENUE_VALUES[0], label: "Student's home" },
  { value: MUSIC_PHYSICAL_VENUE_VALUES[1], label: "Tutor's studio" },
] as const satisfies ReadonlyArray<{ value: MusicPhysicalVenue; label: string }>;

export const MUSIC_QUALIFICATION_TYPES = [
  'Graded examination', 'Diploma', 'Degree', 'Teaching certificate', 'Professional training',
];

export const MUSIC_PORTFOLIO_TYPES = ['Performance video', 'Audio recording', 'Profile', 'Other'];
